export default {"src":"/_next/static/media/CECA_ICONOS_Hogar-Ladron-04.0c8ccbb7.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};